import { Check } from "lucide-react";

import { TEAM_ICONS } from "@/lib/team-icons";
import { cn } from "@/lib/utils";

interface IconPickerProps {
  /** Nome canonico do icone (salvo no backend em ``teams.icon``). */
  value: string;
  onChange: (name: string) => void;
  /** Cor de destaque do icone selecionado. */
  accent?: string;
}

export function IconPicker({ value, onChange, accent }: IconPickerProps) {
  return (
    <div className="grid grid-cols-8 gap-2 rounded-md border border-input bg-background p-2">
      {TEAM_ICONS.map(({ name, Icon, label }) => {
        const selected = value === name;
        return (
          <button
            key={name}
            type="button"
            title={label}
            aria-label={label}
            aria-pressed={selected}
            onClick={() => onChange(selected ? "" : name)}
            className={cn(
              "flex h-9 w-9 items-center justify-center rounded-md border border-transparent transition-colors",
              selected
                ? "border-ring bg-accent text-accent-foreground"
                : "hover:bg-accent/50",
            )}
            style={
              selected && accent
                ? { color: accent, borderColor: accent }
                : undefined
            }
          >
            {selected ? (
              <span className="relative">
                <Icon className="h-5 w-5" />
                <Check className="absolute -right-3 -top-3 h-3 w-3" />
              </span>
            ) : (
              <Icon className="h-5 w-5" />
            )}
          </button>
        );
      })}
    </div>
  );
}
